import { useState, useLayoutEffect } from 'react';
export const useElementWidth = element => {
  const [width, setWidth] = useState(0);
  useLayoutEffect(() => {
    if (!element) return;
    const updateWidth = () => {
      setWidth(element.offsetWidth);
    };
    const observer = new ResizeObserver(updateWidth);
    updateWidth();
    observer.observe(element);
    return () => {
      observer.unobserve(element);
    };
  }, [element]);
  return width;
};